'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('submissions', {
      url: '/account/compliance/submissions',
      template: '<submissions></submissions>'
    });
}



// WEBPACK FOOTER //
// ./client/app/account/compliance/submissions/submissions.routes.js